import React, { Component } from 'react';
import { ScrollView } from 'react-native';
import ListItemRadio from '../../components/common/ListItemRadio';
import I18n from '../../lib/i18n';

class LanguageSelector extends Component<Props> {
  selectLocale = locale => this.props.navigation.setParams({ locale });

  render() {
    return (
      <ScrollView>
        {this.props.availableLocales.map((locale, index) => (
          <ListItemRadio
            title={I18n.translateLocale(locale)}
            first={index === 0}
            key={index}
            onSelect={() => this.selectLocale(locale)}
            selected={
              this.props.route.params?.locale
                ? this.props.route.params?.locale === locale
                : this.props.locale === locale
            }
          />
        ))}
      </ScrollView>
    );
  }
}

type Props = {
  locale: string,
  availableLocales: string[],
};

export default LanguageSelector;
